import { shadeColor } from '@app/utils/utils';
import { graphic } from 'echarts';
import { BASE_COLORS } from '../constants';
import { ITheme } from '../types';

const chartColors = {
  chartTooltipLabel: '#6a7985',
  chartColor1: '#339CFD',
  chartColor1Tint: '#339CFD', // update
  chartColor2: '#dc88f5',
  chartColor2Tint: '#dc88f5', // update
  chartColor3: '#FFB765',
  chartColor3Tint: '#FFB765', // update
  chartColor4: '#306955',
  chartColor4Tint: '#306955', // update
  chartColor5: '#ff3d71',
  chartColor5Tint: '#ff3d71', // update
  chartPrimaryGradient: new graphic.LinearGradient(0, 0, 0, 1, [
    {
      offset: 0,
      color: 'rgba(51, 156, 253, 0.35)',
    },
    {
      offset: 1,
      color: 'rgba(51, 156, 253, 0)',
    },
  ]),
  chartSecondaryGradient: new graphic.LinearGradient(0, 0, 0, 1, [
    {
      offset: 0,
      color: 'rgba(255, 82, 82, 0.35)',
    },
    {
      offset: 1,
      color: 'rgba(255, 82, 82, 0)',
    },
  ]),
  chartSecondaryGradientSpecular: new graphic.LinearGradient(0, 0, 0, 1, [
    {
      offset: 0,
      color: 'rgba(255, 255, 255, 0)',
    },
    {
      offset: 1,
      color: 'rgba(255, 82, 82, 0.5)',
    },
  ]),
};

// Palette M3 teal-dark — đồng bộ thương hiệu (light dùng teal #004c4c);
// thay palette xanh-tím của template Lightence gốc vốn lệch brand.
export const darkColorsTheme: ITheme = {
  primary: '#6fc7c5',
  primary1: '#86d4d3',
  primaryGradient: 'linear-gradient(211.49deg, #86d4d3 15.89%, #4fa9a7 48.97%)',
  light: '#696969',
  secondary: '#7bafff',
  error: '#ffb4ab',
  warning: '#FFB765',
  success: '#57D682',
  background: '#0e1513',
  secondaryBackground: '#161d1c',
  secondaryBackgroundSelected: shadeColor('#161d1c', -5),
  additionalBackground: '#1b2322',
  collapseBackground: '#1b2322',
  timelineBackground: '#1f2726',
  siderBackground: '#0c1716',
  spinnerBase: '#5eead4',
  scroll: '#4a5553',
  border: '#3f4947',
  borderNft: '#4a5553',
  textMain: '#dde4e2',
  textLight: '#9fabaa',
  textSuperLight: '#5c6664',
  textSecondary: '#dde4e2',
  textDark: '#404040',
  textNftLight: '#9fabaa',
  textSiderPrimary: '#a2f0ef',
  textSiderSecondary: '#8fa3a0',
  subText: '#8b9694',
  shadow: 'rgba(0, 0, 0, 0.25)',
  boxShadow: 'none',
  boxShadowHover: 'none',
  boxShadowNft: '0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
  boxShadowNftSecondary:
    '0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
  dashboardMapBackground: '#0e1513',
  dashboardMapCircleColor: '#9fabaa',
  dashboardMapControlDisabledBackground: '#7e7e7e',
  notificationSuccess: '#EFFFF4',
  notificationPrimary: '#D7EBFF',
  notificationWarning: '#FFF4E7',
  notificationError: '#FFE2E2',
  heading: BASE_COLORS.white,
  borderBase: '#3f4947',
  disable: '#7e7e7e',
  disabledBg: '#1f2726',
  layoutBodyBg: '#0e1513',
  layoutHeaderBg: '#0e1513',
  layoutSiderBg: '#0c1716',
  inputPlaceholder: 'rgba(221, 228, 226, 0.5)',
  itemHoverBg: '#1f2726',
  backgroundColorBase: '#1f2726',
  avatarBg: '#1f2726',
  alertTextColor: '#000',
  breadcrumb: '#9fabaa',
  icon: '#9fabaa',
  iconHover: '#ffffff',
  ...chartColors,
};

export const antDarkColorsTheme = {
  successBg: '#e6fff2',
  successBorder: '#79fcc4',
};
